import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ContenedorInfo, ApiResponse } from '@/types/mySttlementDetailType';

type QueryType = {
  oidLiquidacion: number | null;
};

export const getSettlementDetail = async (
  query: QueryType
): Promise<ContenedorInfo[]> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.MySettlementDetail,
      query
    );
    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
